export const paymentProcessingRoutes = {
  CHOOSE_PAYMENT_METHOD: "choosePaymentMethod",
  CONFIGURE_PAYMENT_METHOD: "configurePaymentMethod",
  PAY: "pay",
  CONFIGURE_PAYMENT: "confirmPayment",
  SAVE_PAYMENT_PREFERENCES: "savePaymentPreferences",
  LEGACY_PAYMENT_OPPOSITION: "payment_opposition",
};
